import { render } from "./Length.svg?vue&type=template&id=7d2715e0"
const script = {}
script.render = render

export default script